import { motion } from "framer-motion";
import { Eyebrow } from "@/components/site/Reveal";

export const PageHeader = ({ eyebrow, title, intro, image }) => (
  <section className="relative pt-36 md:pt-44 pb-16 md:pb-20 overflow-hidden" data-testid="page-header">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/70 to-navy/60" />
      </>
    )}
    <div className={`relative z-10 mx-auto max-w-7xl px-5 md:px-8 ${image ? "text-white" : ""}`}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <Eyebrow className={image ? "!text-gold" : ""}>{eyebrow}</Eyebrow>
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className={`mt-6 font-serif font-light text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-4xl ${image ? "text-white" : "text-navy"}`}
      >
        {title}
      </motion.h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className={`mt-7 max-w-2xl text-base md:text-lg leading-relaxed ${image ? "text-white/80" : "text-muted-foreground"}`}
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
